export default {
  label: {
    id: 'resolution_flow_return_confirmation_page_cta_get_more_help',
    defaultMessage: 'Get more help',
  },
  toastErrorTitle: {
    id: 'error_toast_intercom_not_available_title',
    defaultMessage: 'Hmm, we’re glitching',
  },
  toastErrorContent: {
    id: 'error_toast_intercom_not_available_content',
    defaultMessage: 'Something went wrong on our end. Please try again.',
  },
}
